import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {defaultPagination} from "../../util/Util"

const SiteCustomerSelectionTable = ({ dataSource, loading}) => {
    const columns = [
        {
            title: 'Client selection that the site is in',
            dataIndex: 'selectionName',
            width:180
        },
        {
            title: 'Client Specific site ID in client system',
            dataIndex: 'customerId',
            width: 180
        }
    ];

    return (
        <Table
            dataSource={dataSource}
            loading={loading}
            columns={columns}
            size="small"
            bordered
            pagination={defaultPagination()}
        />
    );
};

SiteCustomerSelectionTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    loading: PropTypes.bool.isRequired
};

export default SiteCustomerSelectionTable



// WEBPACK FOOTER //
// ./src/js/browse/site/SiteCustomerSelectionTable.js